import { FolderVolumesNames, FolderVolumesShorthand } from "models/types";
import {
	AnalysisEventDocumentFolder,
	ApplicationFormDocumentFolder,
	DocumentFolderType,
	RootFolder
} from "services/types";

export const getRootFolderLabel = (
	rootFolder: string | RootFolder | undefined,
	isShorthand: boolean
) => {
	if (rootFolder === undefined) return "";
	if (!isShorthand)
		return rootFolder === RootFolder.VOLUME_1
			? FolderVolumesNames.VOLUME_1
			: rootFolder === RootFolder.VOLUME_2
			? FolderVolumesNames.VOLUME_2
			: "";
	return rootFolder === RootFolder.VOLUME_1
		? FolderVolumesShorthand.VOLUME_1
		: rootFolder === RootFolder.VOLUME_2
		? FolderVolumesShorthand.VOLUME_2
		: "";
};

type GenericDocumentFolder =
	| AnalysisEventDocumentFolder
	| DocumentFolderType
	| ApplicationFormDocumentFolder;

export const sortDocumentFoldersByRootFolder = (
	folders: GenericDocumentFolder[],
	isShorthand: boolean
) => {
	return Object.values(RootFolder)
		.filter((value) => !Number.isNaN(Number(value)))
		.map((rootFolder) => {
			const rootFolderLabel = getRootFolderLabel(rootFolder, isShorthand);
			return {
				folders: folders.filter((item) => item.rootFolder === rootFolder),
				label: rootFolderLabel
			};
		});
};
